import { DataTable } from 'simple-datatables';

const componentSelector =
  'table:not(.responsive-table--initialised), .responsive-table__table';

/**
 * @param {Element} table
 */
export function applyOverflowIndicators(table) {
  const maxScroll = table.scrollWidth - table.clientWidth;

  if (table.scrollLeft > 0) {
    table.classList.add('responsive-table--scroll-left');
  } else {
    table.classList.remove('responsive-table--scroll-left');
  }

  if (table.scrollLeft < maxScroll) {
    table.classList.add('responsive-table--scroll-right');
  } else {
    table.classList.remove('responsive-table--scroll-right');
  }
}

export function ResponsiveTable(scope = document) {
  scope.querySelectorAll(componentSelector).forEach(el => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('responsive-table');

    if (el instanceof HTMLTableElement) {
      /* eslint-disable-next-line */
      new DataTable(el, {
        searchable: false,
        fixedHeight: true,
        sortable: false,
        perPage: 20,
        perPageSelect: [20, 50],
      });
    }

    el.classList.add('responsive-table--initialised');
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);

    applyOverflowIndicators(el);
    wrapper.addEventListener('scroll', ({ target }) =>
      applyOverflowIndicators(target)
    );
  });

  window.addEventListener('resize', () => {
    scope
      .querySelectorAll('.responsive-table')
      .forEach(table => applyOverflowIndicators(table));
  });
}

export default function init(scope = document) {
  if (scope.querySelector(componentSelector)) {
    ResponsiveTable(scope);
  }
}
